export const BALANCE = {
  // Speed upgrade: +15% por nivel (multiplicativo)
  SPEED_UPGRADE_MULTIPLIER: 0.15,

  // Weight upgrade: -15% empuje recibido por nivel
  WEIGHT_PUSH_REDUCTION: 0.15,

  // Weight penalty: -10% velocidad por nivel
  WEIGHT_SPEED_PENALTY: 0.10,

  // Push transmits impact; Control improves acceleration, turning and recovery.
  PUSH_POWER_PER_LEVEL: 0.20,
  CONTROL_EFFECT_PER_LEVEL: 0.12,

  // Costos de upgrade
  UPGRADE_COSTS: {
    1: 3, 2: 5, 3: 8, 4: 12,
  },

  // Weight upgrade costs (más baratos por ser defensivos)
  WEIGHT_UPGRADE_COSTS: {
    1: 2, 2: 4, 3: 7, 4: 10,
  },

  // Speed upgrade costs
  SPEED_UPGRADE_COSTS: {
    1: 2, 2: 4, 3: 7, 4: 10,
  },

  // MMR
  MMR_K_FACTOR: 32,
  MMR_INITIAL: 1000,
  MMR_MIN: 0,
  MMR_MAX: 5000,

  // Placement points for MMR calculation
  MMR_PLACEMENT_WEIGHTS: {
    1: 1.0,     // 1er lugar: 100% ganancia
    2: 0.7,     // 2do: 70%
    3: 0.5,     // 3ro: 50%
    4: 0.3,     // 4to: 30%
    5: 0.2,     // 5to: 20%
    6: 0.1,     // 6to: 10%
    7: 0.05,    // 7mo: 5%
    8: 0.0,     // 8vo+: 0%
  },

  // Cosméticos
  COSMETIC_PRICES: {
    common: 100,
    rare: 300,
    epic: 800,
    legendary: 2000,
    season_pass: 500,
  },

  // Monedas por acción
  COINS_PER_MATCH: 50,
  COINS_PER_WIN: 200,
  COINS_PER_ELIMINATION: 25,
  COINS_PER_ORB: 5,
} as const;
